import { call, put } from 'redux-saga/effects';
import { FetchKPIDataRequestAction, FetchKPIChartDataRequestAction } from './actions';
import { fetchKPIDataSuccess, fetchKPIDataFailure, fetchKPIChartDataSuccess, fetchKPIChartDataFailure } from './actions';
import { fetchKPIDataComplete, fetchKPIChartData } from '../../api/strapiGop';

export function* fetchKPIDataSaga(action: FetchKPIDataRequestAction) {
  try {
    const { filters } = action.payload;
    const kpiData: { answers: any[]; statuses: any[] } = yield call(fetchKPIDataComplete, filters);
    yield put(fetchKPIDataSuccess(kpiData.answers, kpiData.statuses));
  } catch (error: any) {
    const errorMessage = error?.message || 'Ошибка при загрузке данных KPI';
    yield put(fetchKPIDataFailure(errorMessage));
  }
}

export function* fetchKPIChartDataSaga(action: FetchKPIChartDataRequestAction) {
  try {
    const { filters } = action.payload;
    const chartData: { kpiPlan: any[]; kpiFact: any[] } = yield call(fetchKPIChartData, filters);
    yield put(fetchKPIChartDataSuccess(chartData.kpiPlan, chartData.kpiFact));
  } catch (error: any) {
    const errorMessage = error?.message || 'Ошибка при загрузке данных графика KPI';
    yield put(fetchKPIChartDataFailure(errorMessage));
  }
}
